// formats the number to at most 2 decimal places
export function formatNumber(n: number): number {
  return Math.round(n * 100) / 100;
}
